import { useState, useRef } from "react";
import { Overlay, Tooltip } from "react-bootstrap";
import { practiceProps } from "src/pages/actionDashboard/types";



const WidgetWithTooltip = ({physician, caseId, practice,}: {
    physician: string; caseId: number; practice: practiceProps; }) => {
    const [show, setShow] = useState(false);
    const target = useRef<HTMLDivElement | null>(null);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const handleMouseEnter = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setShow(true);
    };

    const handleMouseLeave = () => {
        timeoutRef.current = setTimeout(() => {
            setShow(false);
        }, 100);
    };

    return (
        <>
            <div
                id={`physician-target-${caseId}`}
                className="d-inline-flex align-items-center"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                ref={target}
            >
        <span
            className="text-primary d-inline-block position-relative"
            role="button"
            tabIndex={0}
            aria-label={physician}
        >
          {physician}
        </span>
            </div>

            <Overlay
                target={target.current}
                show={show}
                placement="top"
                container={document.body}
                popperConfig={{
                    strategy: "fixed",
                }}
            >
                {(overlayProps) => (
                    <Tooltip
                        id={`physician-tooltip-${caseId}`}
                        className="custom-tooltip"
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        {...overlayProps}
                    >
                        <p className="text-start">
                            <strong>Practice Name:</strong> {practice?.name}
                        </p>
                        <p className="text-start">
                            <strong>Address:</strong> {practice?.address}
                        </p>
                        <p className="text-start">
                            <strong>Phone:</strong> {practice?.phone_number}
                        </p>
                        <p className="text-start mb-0">
                            <strong>Fax:</strong> {practice?.fax_number}
                        </p>
                    </Tooltip>
                )}
            </Overlay>
        </>
    );
};

export default WidgetWithTooltip
